<template>
    <div class="text-center">
         <div class="mb-5">
            <button
                class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-3 rounded-full text-followup-nav"
                @click="generateReport" type="button">
                Get Report
            </button>
        </div>
        <div class="rounded w-full px-2 text-grey-darkest">
            <div v-for="lead of leads" :key="lead.id">
                <input type="checkbox" name="to_generate" :value="lead.id" :id="lead.code" v-model="selectedLeads">
                <label :for="lead.code">{{lead.code}}</label>
            </div>
        </div>
    </div>
</template>

<script>
import Mixin from './mixin';

export default {
    mixins: [Mixin],
    name: 'lead-recap-options',
    data() {
        return {
            selectedLeads: [],
            leads: []
        }
    },
    created(){
        this.getLeads();
    },

    methods: {
        getValue(lead){
            return {
                id: lead.id,
            }
        },
        getLeads(){
            self = this;
            axios.get(route('api.settings.codes.lead-from.index')).then((response) => {
                self.leads = response.data;
                self.leads.unshift({id: 0, code: 'All'});
            });
        },

        generateReport(){
            if(this.selectedLeads.length < 1) return;
            this.getQueryParams();
            this.uri += '&type=' + JSON.stringify(this.selectedLeads) + '&pdf=true';
            window.location = "/reports-charts/lead-recap" + this.uri;
        }
    }
}
</script>
